import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {onFormQueryError} from '../../errors/on-form-query-error';
import {useNavigate} from '../../utils/hooks/use-navigate';
import {apiClient} from '../../http/query-client';
import {useBootstrapData} from '../../core/bootstrap-data/bootstrap-data-context';
import {useAuth} from '../use-auth';

interface Response extends BackendResponse {
  bootstrapData?: string;
  message?: string;
  status: 'success' | 'needs_email_verification';
}

export interface RegisterPayload {
  first_name: string;
  last_name: string;
  phone: string;
  onboarding_role: string;
  email: string;
  password: string;
  password_confirmation: string;
}

interface UseRegisterOptions {
  useRegistrationRedirect?: boolean;
}

export function useRegister(
  form: UseFormReturn<RegisterPayload>,
  options: UseRegisterOptions = {},
) {
  const navigate = useNavigate();
  const {getRedirectUri, getRegistrationRedirectUri} = useAuth();
  const {setBootstrapData} = useBootstrapData();

  return useMutation({
    mutationFn: register,
    onSuccess: response => {
      setBootstrapData(response.bootstrapData!);
      const redirectUri =
        options.useRegistrationRedirect === false
          ? getRedirectUri()
          : getRegistrationRedirectUri();
      navigate(redirectUri, {replace: true});
    },
    onError: r => onFormQueryError(r, form),
  });
}

function register(payload: RegisterPayload): Promise<Response> {
  return apiClient
    .post('auth/register', payload)
    .then(response => response.data);
}
